<footer class="footer">
  <div class="container-fluid">
    <div class="copyright pull-right" style="color: #fff !important">
     <span> Versi&oacute;n Fase III: 24-10-2025 | {{ dateTime | date : "d 'de' MMMM 'de' y"  }}</span>,             
      <a target="https://www.solsersistem.net">Solser | Information Technology &copy; {{ dateTime | date : "y"  }}</a> 
    </div>
  </div>
</footer>